export default {
    CLEAR: 'CLEAR_PROSPECT_ROUTE',
    CHANGE: 'CHANGE_PROSPECT_ROUTE'
}
